import { createContext, useContext } from 'react';
const BoxContext = /*#__PURE__*/createContext({
  width: 0,
  gridColumns: 12
});
export const BoxProvider = BoxContext.Provider;
export const useBoxContext = () => {
  const context = useContext(BoxContext);
  if (!context) {
    throw new Error('Box.Item must be used within a Box');
  }
  return context;
};